<template>
    <div>
        <div class="btn-sel" @click="handleClickSelect">
            <span v-if="!newValue" class="name">{{optName}}</span>
            <div class="txt" v-else>
                <VideoBox
                  class="vb"
                  v-if="['video', 'audio'].includes(type)"
                  :url.sync="newValue"
                />
                <img v-else crossOrigin="anonymous" class="img" :src="newValue" alt="" />
            </div>
            <div v-if="newValue" class="zhezhao">
                <span class="btn" @click.stop="edit">编辑</span>
                <!-- <span class="btn">查看</span> -->
                <span class="btn" @click.stop="newValue=''">删除</span>
            </div>
        </div>

        <More
            v-if="isMore"
            :isEdit="true"
            :value.sync="newValue"
            :visible.sync="isMore"
            :type.sync="type"
            :isCocos="true"
        />
    </div>
</template>

<script>
import More from './components/more'
import VideoBox from './components/video'
export default {
  name: 'file-dialog',
  components: {
    More,
    VideoBox
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    type: String
  },
  computed: {
    optName () {
      let name = '选择'
      switch (this.type) {
        case 'image':
          name = '选择图片'
          break
        case 'audio':
          name = '选择音频'
          break
        case 'video':
          name = '选择视频'
          break
        case 'animation':
          name = '选择动画'
          break
      }
      return name
    }
  },
  watch: {
    value (vl) { this.newValue = vl },
    newValue (vl) { this.$emit('update:value', vl) }
  },
  created () {
  },
  data () {
    return {
      newValue: this.value,
      isMore: false,
      newType: this.type
    }
  },
  methods: {
    handleClickSelect () {
      if (!this.value) {
        // 素材库选择
        this.edit()
      }
    },
    edit () {
      this.isMore = true
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-sel{
    display: inline-flex;
    height: 36px;
    min-width: 200px;
    border: 2px dashed #ebebeb;
    color: #a1a1a1;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    text-align: center;
    position: relative;

    .zhezhao{
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0px;
        top: 0px;
        border-color: rgba(0,0,0,.5);
        background-color: rgba(0,0,0,.5);
        box-shadow: 0 0 10px 2px rgba(0,0,0,.5);
        border-radius: 10px;
        display: none;

        .btn{
            margin: 0px 6px;

            &:hover{
                color: #faaf00;
            }
        }
    }
    &:hover {
        color: #20a0ff;
        border-color: #20a0ff;
        cursor: pointer;

        .zhezhao{
            display: block !important;
        }
    }

    .txt {
        width: 100%;
        height: 100%;
        position: relative;

        .vb{
          width: 200px;
          height: 100%
        }

        .img {
            max-width:200px;
            height: 100%;
            object-fit: contain;
        }
    }
}
</style>
